import React, { useState } from 'react'
import UserService from '../services/UserService'
  
function Status() {
    const [status, setStatus] = useState(true)

    UserService.onConnect = () => {
        setStatus(true)
    }

    UserService.onDisconnect = () => {
        setStatus(false)
    }

    return (
        status ? 
        <div className="status online">Online</div> :
        <div className="status offline">Offline</div>
    )
}

export default Status